export default __webpack_public_path__ + "static/media/spark_38.932a8f08.png";